import React from 'react';
import { Link as RouterLink } from 'react-router';
import { Link } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface BackLinkProps {
  to: string;
  label: string;
}

const BackLink: React.FC<BackLinkProps> = ({ to, label }) => (
  <Link
    component={RouterLink}
    to={to}
    underline="hover"
    sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, mb: 2 }}
  >
    <ArrowBackIcon fontSize="small" />
    {label}
  </Link>
);

export default BackLink;
